"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("bootstrap/dist/css/bootstrap.css");

var _checkIn = _interopRequireDefault(require("./checkIn"));

var _reactstrap = require("reactstrap");

var _reactGeocode = _interopRequireDefault(require("react-geocode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CheckinMap = function CheckinMap(props) {
  var _useState = (0, _react.useState)({
    lat: "",
    lng: ""
  }),
      _useState2 = _slicedToArray(_useState, 2),
      coords = _useState2[0],
      setCoords = _useState2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedAddress = _useState4[0],
      setSelectedAddress = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      _useState6 = _slicedToArray(_useState5, 2),
      defaultLocation = _useState6[0],
      setDefaultLocation = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = _slicedToArray(_useState7, 2),
      defaultAddress = _useState8[0],
      setDefaultAddress = _useState8[1];

  _reactGeocode.default.setApiKey(props.config.API_KEY);

  _reactGeocode.default.setLanguage(props.config.LANGUAGE);

  _reactGeocode.default.setRegion(props.config.REGION);

  _reactGeocode.default.setLocationType("ROOFTOP");

  _reactGeocode.default.enableDebug();

  var onCheckinHandler = function onCheckinHandler(position, address) {
    if (props.onCheckinHandler) {
      props.onCheckinHandler(position, address);
    }
  };

  (0, _react.useEffect)(function () {
    var _navigator;

    (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.geolocation.getCurrentPosition(function (_ref) {
      var _ref$coords = _ref.coords,
          lat = _ref$coords.latitude,
          lng = _ref$coords.longitude;
      var pos = {
        lat: lat,
        lng: lng
      };
      setDefaultLocation(pos);

      _reactGeocode.default.fromLatLng(lat, lng).then(function (response) {
        var address = response.results[0].formatted_address;
        setDefaultAddress(address);
      }, function (error) {// console.error(error);
      });
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Modal, {
    isOpen: props.isActive,
    toggle: props.onCloseHandler
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.ModalHeader, null), /*#__PURE__*/_react.default.createElement(_reactstrap.ModalBody, {
    style: {
      overflowX: "hidden"
    }
  }, /*#__PURE__*/_react.default.createElement(_checkIn.default, {
    config: props.config,
    setCoords: setCoords,
    onCloseHandler: props.onCloseHandler,
    currentLocation: defaultLocation,
    height: props.height ? props.height : '500px',
    currentAddress: defaultAddress,
    setSelectedAddress: setSelectedAddress,
    onCheckinHandler: onCheckinHandler,
    locationLabel: props.locationLabel,
    okayButtonText: props.okayButtonText,
    cancelButtonText: props.cancelButtonText
  }))));
};

var _default = CheckinMap;
exports.default = _default;